/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：748__part-1
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_315 from /* 315 */"../315"
import * as /* [auto-meaningful-name] */Module_801 from /* 801 */"../801/index"
import * as /* [auto-meaningful-name] */Module_614 from /* 614 */"../614"
Module_614.a("success", "processing", "error", "default", "warning")
var v = Module_614.a("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime")
export { v }
